import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { axiosInstance } from '@appblocks/frontend/client/utils';
import { Link, useHistory } from 'react-router-dom';
import Table from 'react-bootstrap/Table';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Dropdown from 'react-bootstrap/Dropdown';
import { BsThreeDotsVertical } from 'react-icons/bs';
import Collapse from 'react-bootstrap/Collapse';
import ReadMoreComponent from '@appblocks/frontend/client/Components/ReadMoreComponent';
import DataPaginationRenderer from '@appblocks/frontend/cloudclient/Components/DataPaginationRenderer';
import ModelSelect from './Components/ModelSelect';


export default function PageDeviceGroups(props) {
    const [groups, setGroups] = useState([]);
    const [total, setTotal] = useState(0);
    const [editGroup, setEditGroup] = useState(false);
    const [currentGroup, setCurrentGroup] = useState(undefined);
    const [groupName, setGroupName] = useState('');
    const [project, setProject] = useState('');
    const [version, setVersion] = useState('');
    const workspaces = useSelector(state => state.workspaces);
    const history = useHistory();
    const [open, setOpen] = useState(false);


    useEffect(() => {
        if (editGroup) {
            setProject('');
            setGroupName('');
        }
    }, [editGroup]);

    useEffect(() => {
        setVersion('');
    }, [project]);

    const getGroups = async ({ search, start, count }) => {
        setCurrentGroup(undefined);
        const res = await axiosInstance.get(`${process.env.API_URL}/cgg/groups`, {
            params: {
                search,
                start,
                count,
                workspace: workspaces.currentWorkspace,
            },
        });
        if (res.data.data) {
            setGroups(res.data.data);
            setTotal(res.data.count);
        }
    };

    function removeGroup(group) {
        if (!window.confirm(`Remove Device Group ${group.name}?`)) {
            return;
        }
        axiosInstance.delete(`${process.env.API_URL}/cgg/groups/${group._id}`, {

        })
            .then((res) => {
                getGroups({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    }

    function createGroup(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        setEditGroup(false);
        axiosInstance.post(`${process.env.API_URL}/cgg/groups`, {
            name: groupName,
            project,
            version,
            workspace: workspaces.currentWorkspace,
        })
            .then((res) => {
                history.push(`/groups/${res.data._id}`);
            });
        return false;
    }

    function saveGroup(e) {
        if (e !== undefined) {
            e.preventDefault();
        }
        axiosInstance.put(`${process.env.API_URL}/cgg/groups/${currentGroup._id}`, {
            ...currentGroup,
        })
            .then((res) => {
                getGroups({
                    search: '',
                    start: 0,
                    count: 10,
                });
            });
    }

    return (
        <>
            <div className="container pt-3">
                <h3>Device Groups</h3>
                <Button className="mb-3" onClick={() => setEditGroup(true)}>
                    + New Device Group
                </Button>
                <DataPaginationRenderer
                    total={total}
                    getItems={getGroups}
                >
                    <Table>
                        <thead className="table-secondary">
                            <tr>
                                <th>Name</th>
                                <th>Devices</th>
                                <th>Last Updated</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {groups.length === 0 && (
                                <tr>
                                    <td colSpan={10}>
                                        <div className="table-empty-state-container">
                                            There are no device groups in this workspace (yet).
                                        </div>
                                    </td>
                                </tr>
                            )}
                            {groups.map((group) => {
                                return (
                                    <tr key={group._id} className="align-middle">
                                        <td>
                                            <Link to={`/groups/${group._id}`}>
                                                {group.name}
                                            </Link>
                                        </td>
                                        <td>
                                            {group.devices.length}
                                        </td>
                                        <td>{new Date(group.updatedAt).toLocaleString()}</td>
                                        <td>
                                            <Dropdown className="">
                                                <Dropdown.Toggle variant="light" className="dropdown-custom float-end">
                                                    <BsThreeDotsVertical />
                                                </Dropdown.Toggle>
                                                <Dropdown.Menu>
                                                    <Dropdown.Item
                                                        onClick={() => setCurrentGroup(group)}
                                                    >
                                                        Rename
                                                    </Dropdown.Item>
                                                    <Dropdown.Item
                                                        onClick={(() => removeGroup(group))}
                                                    >
                                                        Delete
                                                    </Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </Table>
                </DataPaginationRenderer>
                <div className="p-5 bg-body-secondary rounded-3">
                    <ReadMoreComponent
                        initialText={(
                            /* eslint-disable */
                            <>
                                <h5 className="text-body-emphasis">About Device Groups</h5>
                                <p>
                                    Device groups simplify the management of identical devices. Identical devices are the devices executing the same <b>AppBlocks</b> application of the same version. You specify the group's application and its version (app/ver) when creating a device group. You can change the app/ver of a group at any time.
                                </p>
                            </>
                            /* eslint-enable */
                        )}
                        readMoreText={(
                            /* eslint-disable */
                            <>
                                <p>
                                    Once a group is created, you can add devices to this group. Any device can only be a member of one group. Any devices may be added to any group, but only the devices running the matching app/ver will be active within the group. Devices with a different app/version will be marked as mismatched.
                                </p>
                                Device groups facilitate gang management of the member devices' settings and data tables. This is achieved through the setting and data table delegation. When you delegate a setting to a group, this group gains the ability to control the value of this setting for all active devices in the group.
                                <p>
                                    Setting delegation is performed separately for each setting of the group's app/version. Only the settings that have the read/write access from the cloud can be delegated. Delegated settings cannot be edited on the individual device level. The data table delegation works in the same way.
                                </p>
                                <p>
                                    Device groups also support gang firmware (application) upload into all member devices (and not just matching devices). After updating the firmware of all member devices, you will often need to change the app/version setting for the group.
                                </p>
                            </>
                            /* eslint-enable */
                        )}
                    />
                </div>
            </div>

            <Modal
                scrollable
                show={editGroup}
                onHide={() => setEditGroup(false)}
            >
                <Form onSubmit={e => createGroup(e)}>
                    <Modal.Header closeButton>
                        <Modal.Title>
                            <span>Create Device Group</span>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Device Group Name</Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Device Group Name"
                                value={groupName}
                                onChange={e => setGroupName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Application</Form.Label>
                            <ModelSelect
                                model="projects"
                                onChange={value => setProject(value)}
                                value={project}
                            />
                        </Form.Group>
                        {project && (
                            <Form.Group className="mb-3">
                                <Form.Label>Version</Form.Label>
                                <ModelSelect
                                    model="versions"
                                    apiRoute={`/api/projects/${project}/versions`}
                                    onChange={value => setVersion(value)}
                                    nameProperty="versionCode"
                                    value={version}
                                />
                            </Form.Group>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={groupName === '' || project === '' || version === ''}
                        >
                            Create Device Group
                        </Button>
                        <Button variant="secondary" onClick={() => setEditGroup(false)}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
            {currentGroup && (
                <Modal
                    scrollable
                    show={currentGroup !== undefined}
                    onHide={() => setCurrentGroup(undefined)}
                >
                    <Form onSubmit={e => saveGroup(e)}>
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <span>Edit Device Group</span>
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>

                            <Form.Group className="mb-3">
                                <Form.Label>Device Group Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Device Group Name"
                                    value={currentGroup.name}
                                    onChange={e => setCurrentGroup(
                                        { ...currentGroup, name: e.target.value },
                                    )}
                                />
                            </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="primary" type="submit">
                                Save
                            </Button>
                            <Button variant="secondary" onClick={() => setCurrentGroup(undefined)}>
                                Cancel
                            </Button>
                        </Modal.Footer>
                    </Form>
                </Modal>
            )}
        </>
    );
}
